import { render } from "./Check-Component.vue?vue&type=template&id=86f28a7a"
import script from "./Check-Component.vue?vue&type=script&lang=js"
export * from "./Check-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__